import React from 'react';
import SalesForm from '../../components/Forms/SalesForm';

function Sales() {
  return (
    <>
      <SalesForm />
    </>
  )
}

export default Sales